import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../api";

// Tracks the open pending-changes count for the nav badge. Polls every 30s
// and exposes refresh() so approve/dismiss actions update it immediately.
const PendingContext = createContext({ count: 0, refresh: () => {} });

export function PendingProvider({ children }) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const { changes } = await api("/pending-changes?status=pending&limit=500");
      setCount(changes.length);
    } catch {
      /* leave last known count on transient error */
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);

  return <PendingContext.Provider value={{ count, refresh }}>{children}</PendingContext.Provider>;
}

export function usePending() {
  return useContext(PendingContext);
}
